import React from 'react';
import { Link } from 'react-router-dom';
import ROUTES from '../routes.json';
import PageHelmet from '../components/PageHelmet';
import { normalizeRoute } from '../utils/routeHelpers';

export default function AboutPage() {
  return (
    <section className="tool-area">
      <PageHelmet
        title="About OneAI — Human-first AI Tools"
        description="OneAI builds human-first tools that help teams create clearer, friendlier content at scale. Learn about our mission, values, and team." 
        canonical={window.location.origin + ROUTES.about.path}
      />
      <h1 className="page-title">About OneAI</h1>

      <div className="page-content" style={{ marginTop: 12, color: '#6b7280' }}>
        <p>
          OneAI builds simple, human-first tools that help teams create clearer, friendlier content at scale. We combine modern language models with human-centered controls so outputs read like they were edited by a real person. Our tools are designed for editors, marketers, and customer teams who need speed without losing voice.
        </p>
        <p>
          By focusing on tone, clarity, and usability we help reduce editing time and improve reader engagement. Whether you're humanizing AI drafts, generating captions, or building blog outlines, OneAI helps you produce consistent, on-brand content faster.
        </p>
        <ul style={{ marginTop: 8 }}>
          <li>Human-first editing controls to keep tone consistent.</li>
          <li>Quick outputs designed for real publishing workflows.</li>
          <li>Privacy-aware processing and straightforward integration options.</li>
        </ul>
      </div>

      <div className="tool-controls">
        <div className="usage">About OneAI</div>
      </div>

      <div className="tool-grid">
        <div className="panel panel-left">
          <h3 style={{ marginTop: 0 }}>Our Mission</h3>
          <p style={{ color: '#6b7280' }}>
            OneAI creates tools that make content feel human without sacrificing scale. We combine advanced models with
            human-centric design to help brands communicate clearly and authentically.
          </p>

          <h4 style={{ marginTop: 12 }}>What we value</h4>
          <ul style={{ marginTop: 8, color: '#6b7280' }}>
            <li>Clarity & honesty</li>
            <li>Design-driven product</li>
            <li>Privacy-first approach</li>
            <li>Continuous improvement</li>
          </ul>
        </div>

        <div className="panel panel-right">
          <h3 style={{ marginTop: 0 }}>Team & Story</h3>
          <div style={{ display: 'grid', gap: 12, marginTop: 8 }}>
            <div>
              <strong>Founders</strong>
              <div style={{ color: '#6b7280' }}>
                AI researchers and product builders focused on usable ML.
              </div>
            </div>
            <div>
              <strong>Careers</strong>
              <div style={{ color: '#6b7280' }}>
                We’re hiring engineers, designers, and growth folks. Reach out via the contact page or email us directly at <a href="mailto:info.onehubtech@gmail.com">info.onehubtech@gmail.com</a>.
              </div>
            </div>
            <div>
              <strong>Press & partnerships</strong>
              <div style={{ color: '#6b7280' }}>
                For press or partnership enquiries email <a href="mailto:info.onehubtech@gmail.com">info.onehubtech@gmail.com</a> or call <a href="tel:+917010512892">+91 70105 12892</a>.
              </div>
            </div>
            <div>
              <strong>Contact</strong>
              <div style={{ color: '#6b7280' }}>
                General inquiries: <a href="mailto:info.onehubtech@gmail.com">info.onehubtech@gmail.com</a><br />
                Phone: <a href="tel:+917010512892">+91 70105 12892</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔗 External Outgoing Link (Fixes Ahrefs “No outgoing links”) */}
      <div style={{ marginTop: 25 }}>
        <p style={{ color: '#6b7280' }}>
          Learn more about global AI research at{' '}
          <a 
            href="https://openai.com" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#4f46e5', fontWeight: '600' }}
          >
            OpenAI
          </a>.
        </p>
      </div>

      <div style={{ marginTop: 20 }}>
        <h4>Explore more</h4>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Link to={normalizeRoute(ROUTES.humanizer.path)} className="btn ghost">Try the Humanizer</Link>
          <Link to={normalizeRoute(ROUTES.blog.path)} className="btn ghost">Visit our Blog</Link>
          <Link to={normalizeRoute(ROUTES.contact.path)} className="btn ghost">Contact Us</Link>
        </div>
      </div>

    </section>
  );
}
